/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heading_About_PrefixInputs */

const en_heading_about_prefix = /** @type {(inputs: Heading_About_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read`)
};

const ar_heading_about_prefix = /** @type {(inputs: Heading_About_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نبذة`)
};

const bn_heading_about_prefix = /** @type {(inputs: Heading_About_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পড়ুন`)
};

const de_heading_about_prefix = /** @type {(inputs: Heading_About_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lies`)
};

const es_heading_about_prefix = /** @type {(inputs: Heading_About_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lee`)
};

const fr_heading_about_prefix = /** @type {(inputs: Heading_About_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lis`)
};

const pt_heading_about_prefix = /** @type {(inputs: Heading_About_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leia`)
};

const zh_heading_about_prefix = /** @type {(inputs: Heading_About_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读`)
};

const tr_heading_about_prefix = /** @type {(inputs: Heading_About_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oku`)
};

const ru_heading_about_prefix = /** @type {(inputs: Heading_About_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Читать`)
};

const pl_heading_about_prefix = /** @type {(inputs: Heading_About_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeczytaj`)
};

/**
* | output |
* | --- |
* | "Read" |
*
* @param {Heading_About_PrefixInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const heading_about_prefix = /** @type {((inputs?: Heading_About_PrefixInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heading_About_PrefixInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_heading_about_prefix(inputs)
	if (locale === "bn") return bn_heading_about_prefix(inputs)
	if (locale === "de") return de_heading_about_prefix(inputs)
	if (locale === "es") return es_heading_about_prefix(inputs)
	if (locale === "fr") return fr_heading_about_prefix(inputs)
	if (locale === "pt") return pt_heading_about_prefix(inputs)
	if (locale === "zh") return zh_heading_about_prefix(inputs)
	if (locale === "tr") return tr_heading_about_prefix(inputs)
	if (locale === "ru") return ru_heading_about_prefix(inputs)
	if (locale === "pl") return pl_heading_about_prefix(inputs)
	return en_heading_about_prefix(inputs)
});